import React, { lazy } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function EbookContents() {
  const modules = [{
    title: 'Fundamentos del Wellaging Celular',
    subtitle: 'Entendé por qué tu cuerpo está donde está (y cómo revertirlo).',
    learn: ['Por qué el 90% de los tratamientos antiaging fracasan', "Test de perfil wellaging: descubrí tu 'edad biológica' real", "El concepto de 'inflamómetro corporal'"],
    result: 'Claridad absoluta sobre tu punto de partida.'
  }, {
    title: 'Nutrición Antiinflamatoria',
    subtitle: 'Cómo dejar de inflamarte silenciosamente todos los días.',
    learn: ['Plan de alimentación de 30 días (ingredientes de supermercado)', 'Los 12 alimentos que aceleran el envejecimiento', 'Qué comer EXACTAMENTE para reducir hinchazón facial'],
    result: 'Menos hinchazón, más energía y digestión mejorada en 10 días.'
  }, {
    title: 'Protocolo de Piel Regenerativa',
    subtitle: 'Recuperá la luminosidad sin gastar fortunas.',
    learn: ['Rutina AM/PM personalizada de 5 minutos', 'Los 3 activos científicamente probados que sí funcionan', 'Productos argentinos recomendados por presupuesto'],
    result: 'Piel más hidratada, firme y luminosa en 14 días.'
  }, {
    title: 'Movimiento Inteligente Post-40',
    subtitle: 'Preservá tu masa muscular sin vivir en el gimnasio.',
    learn: ['Rutina de 10 minutos en casa (sin equipamiento)', 'Los 5 ejercicios esenciales después de los 40', 'Cómo evitar lesiones y rigidez matutina'],
    result: 'Menos rigidez matutina y más agilidad en 7 días.'
  }, {
    title: 'Sueño Profundo y Bienestar',
    subtitle: 'Apagá la mente y regenerá tu cuerpo de noche.',
    learn: ['El protocolo nocturno de 7 minutos', 'Cómo regular el cortisol que te despierta a las 3 AM', 'Técnica de respiración 4-7-8'],
    result: 'Dormir profundo y despertar sin alarmas en 14 días.'
  }, {
    title: 'Tu Plan de Acción de 30 Días',
    subtitle: 'El mapa exacto para no perderte.',
    learn: ['Calendario semanal completo', 'Checklists diarios imprimibles', 'Plan de mantenimiento post-30 días'],
    result: 'Cero confusión. Sabés exactamente qué hacer cada día.'
  }];
  return <Section bg="cream-light" data-id="element-168">
      <div className="text-center mb-10 md:mb-20" data-id="element-169">
        <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-170">
          El Sistema Completo
        </p>
        <h2 className="text-4xl md:text-6xl font-serif text-charcoal mb-6" data-id="element-171">
          ¿Qué contiene{' '}
          <span className="italic text-olive" data-id="element-172">Wellaging Argentino?</span>
        </h2>
        <p className="text-xl text-charcoal-light font-light" data-id="element-173">
          60 Páginas de Ciencia Aplicada, Paso a Paso
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid lg:grid-cols-[1fr_1.5fr] gap-8 lg:gap-16 items-start" data-id="element-174">
        {/* Mockup Image */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="sticky top-32" data-id="element-175">
          <div className="relative aspect-square rounded-2xl overflow-hidden shadow-2xl border border-gold/20 bg-cream-dark" data-id="element-176">
            <img src="https://cdn.magicpatterns.com/uploads/cKPHZGzEjSA7MPjy1gxhWe/portada_ebook_PRINCIPAL.png" alt="Wellaging Argentino - Portada del Ebook" width={600} height={600} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-177" />
          </div>
        </motion.div>

        {/* Modules List */}
        <div className="space-y-8" data-id="element-178">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group relative pl-8 md:pl-12" data-id="element-179">
              {/* Timeline line */}
              <div className="absolute left-[11px] top-10 bottom-[-2rem] w-px bg-gold/20 group-last:hidden" data-id="element-180" />

              {/* Number node */}
              <div className="absolute left-0 top-1 w-6 h-6 rounded-full border border-gold bg-cream-light flex items-center justify-center z-10" data-id="element-181">
                <div className="w-1.5 h-1.5 rounded-full bg-olive" data-id="element-182" />
              </div>

              <div className="glass-card p-6 md:p-8 rounded-2xl transition-all hover:bg-white/80" data-id="element-183">
                <div className="mb-6" data-id="element-184">
                  <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-2" data-id="element-185">
                    Módulo 0{idx + 1}
                  </p>
                  <h4 className="text-2xl font-serif text-charcoal mb-2" data-id="element-186">
                    {mod.title}
                  </h4>
                  <p className="text-olive font-medium text-sm" data-id="element-187">
                    {mod.subtitle}
                  </p>
                </div>

                <ul className="space-y-3 mb-6" data-id="element-188">
                  {mod.learn.map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal-light font-light text-sm" data-id="element-189">
                      <span className="text-gold mt-0.5" data-id="element-190">+</span>
                      <span data-id="element-191">{item}</span>
                    </li>)}
                </ul>

                <div className="bg-olive/5 p-4 rounded-xl border border-olive/10" data-id="element-192">
                  <p className="text-sm text-charcoal font-medium" data-id="element-193">
                    <span className="text-olive uppercase tracking-widest text-[10px] block mb-1" data-id="element-194">
                      Resultado Tangible
                    </span>
                    {mod.result}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}